import { Message } from 'google-protobuf'
import { PlaceOrderOk, ProductInfoOk, ProductInfoReply, PlaceOrderReply, ValidateDiscountReply, Discount } from 'proto/eshop/Basket_pb'
import { ServiceError } from './ServiceError'
import { grpc } from '@improbable-eng/grpc-web'
import i18n from '@/plugins/i18n'

function validateResponseOk<T extends Message>(ok?: T): T | undefined {
	const isValid = ok ? ((ok: T) => {
		if (ok instanceof PlaceOrderOk) {
			return Boolean(ok.getRedirectUrl()) || Boolean(ok.getHtmlForm())
		} else if (ok instanceof ProductInfoOk) {
			return Boolean(ok.getPictureUrl()) &&
				Boolean(ok.getName()) &&
				Boolean(ok.getPrice100()) &&
				Boolean(ok.getCurrency()) &&
				Boolean(ok.getType())
		} else if (ok instanceof Discount) {
			return ok
		}
	})(ok) : false

	if (isValid) {
		return ok
	}

	const error = new ServiceError(i18n.gettext(`Invalid server response!`), grpc.Code.DataLoss)
	throw error
}

export function unpackResponse(response: PlaceOrderReply | null): PlaceOrderOk
export function unpackResponse(response: ProductInfoReply | null): ProductInfoOk
export function unpackResponse(response: ValidateDiscountReply | null): Discount
export function unpackResponse(response: any) {
	// если запрос завершился с кодом успеха, но в ответе пусто
	if (!response) throw new ServiceError(i18n.gettext('Empty response from the server'), grpc.Code.DataLoss)
	if (response.hasError()) throw response.getError()
	return validateResponseOk(response.getOk())
}

/**
 * Актуализировать переводы перед коммитом
 */
